import React, { useCallback } from 'react';
import Webcam from "react-webcam";
import PropTypes from 'prop-types';
import { RSelect } from "@putil-view/input.r-select";
import { Button } from 'react-bootstrap';
import { FaTimes, FaArrowLeft } from 'react-icons/fa';
import { useScreen } from '@putil-view/use.use-screen';
import 'css/circleButton.css';
import {isIOS} from 'react-device-detect';
export const CaptureImageAndVideo = (props) => {
  const videoType = isIOS ? 'video/mp4' : 'video/webm';
  const [devices, setDevices] = React.useState([]);
  const [deviceLabel, setDeviceLabel] = React.useState('Default');
  const [media, setMedia] = React.useState({ capturing: false, recordedChunks: [] })
  const [state, setState] = React.useState({ stage: "START_VIDEO_RECORDING", lockerImage: '', lockerItems: '', video: null })
  const webcamRef = React.useRef(null);
  const mediaRecorderRef = React.useRef(null);
  const screen = useScreen();

  const handleCaptureResult  = useCallback((result) =>{
		props.setState(prevState =>{
        return{...prevState , ...{lockerImage:result.lockerImage, lockerItems:result.lockerItems, lockerVideo:result.video, lockerVideoUrl: URL.createObjectURL(result.video), stage:"DATA_FORM"}}
      }
  )},[props])


  const handleDevices = React.useCallback(
    mediaDevices =>
      setDevices(mediaDevices.filter(({ kind }) => kind === "videoinput")),
    [setDevices]
  );

  const handleLockerApperance = React.useCallback(
    () => {
      const imageSrc = webcamRef.current.getScreenshot();
      setState((prev) => { return { ...prev, ...{ stage: "CAPTURE_LOCKER_ITEMS", lockerImage: imageSrc } } })
    },
    [webcamRef]
  );

  const handleLockerItems = React.useCallback(
    () => {
      const imageSrc = webcamRef.current.getScreenshot();
      setState((prev) => { return { ...prev, ...{ stage: "STOP_VIDEO_RECORDING", lockerItems: imageSrc } } })
    },
    [webcamRef]
  );
  const handleDataAvailable = React.useCallback(
    ({ data }) => {
      if (data.size > 0) {
        setMedia((prev) => { return { ...prev, ...{ recordedChunks: prev.recordedChunks.concat(data) } } })
      }
    },
    [setMedia]
  );

  const handleStartVideoCapture = React.useCallback(() => {
    setState((prev) => { return { ...prev, ...{ stage: "CAPTURE_LOCKER_APPERANCE" } } })
    setMedia((prev) => { return { ...prev, ...{ capturing: true } } })
    mediaRecorderRef.current = new MediaRecorder(webcamRef.current.stream, {
      mimeType: videoType
    });
    mediaRecorderRef.current.addEventListener(
      "dataavailable",
      handleDataAvailable
    );

    mediaRecorderRef.current.start();
  }, [webcamRef, setMedia, mediaRecorderRef,handleDataAvailable]);


  const handleStopVideoCapture = React.useCallback(() => {
    mediaRecorderRef.current.stop();
    setMedia((prev) => { return { ...prev, ...{ capturing: false } } })
  }, [mediaRecorderRef,  setMedia]);

  const handleSelect = useCallback((event) => {
    if (media.capturing) {

      mediaRecorderRef.current.removeEventListener(
        "dataavailable",
        handleDataAvailable
      );
      mediaRecorderRef.current.stop();
      setMedia({ capturing: false, recordedChunks: [] });
    }
    setDeviceLabel(event.target.value)
  }, [setDeviceLabel, setMedia, media,handleDataAvailable]);



  React.useEffect(
    () => {
      navigator.mediaDevices.enumerateDevices().then(handleDevices);
    },
    [handleDevices, media]
  );

  React.useEffect(
    () => {
      if (state.lockerImage && state.lockerItems && media.recordedChunks.length) {
        const blob = new Blob(media.recordedChunks, {
          type: videoType
        });
        setState((prev) => { return { ...prev, ...{ video: blob } } })
        setMedia((prev) => { return { ...prev, ...{ recordedChunks: [] } } })
      }
    },
    [state.lockerImage, state.lockerItems, media.recordedChunks, setState, setMedia]
  );

  React.useEffect(
    () => {
      if (state.lockerImage && state.lockerItems && state.video) {
        console.log(state);
        handleCaptureResult(state);
      }
    },
    [state, handleCaptureResult]
  );

  const fadeClass = {
    "START_VIDEO_RECORDING": "fade-in",
    "CAPTURE_LOCKER_ITEMS": "fade-in",
    "STOP_VIDEO_RECORDING": "fade-in",
    "CAPTURE_LOCKER_APPERANCE": "fade-out"
  }


  return (
    <>
      {devices && Object.keys(devices).length !== 0 &&
        <>
          <div className="d-flex justify-content-center">
            <RSelect name="camera" id="camera_source_select" label={<>Camera</>} options={['Default'].concat(devices.map(device => { return device.label }))} value={null} handleChange={handleSelect} />
          </div>
          {devices.map((device, key) => (
            <>
              {(device.label === deviceLabel || (deviceLabel === 'Default' && key === 0)) &&
                <>
                  <div>
                    <div className={"d-flex justify-content-center " + fadeClass[state.stage]}>
                      <Webcam
                        ref={webcamRef}
                        style={{
                          height: screen.isWideScreen ? '50vh' : '45vh',
                          width: screen.isWideScreen ? '50vh' : '100%',
                          display: 'flex',
                          justifyContent: 'center',
                          objectFit: 'cover'
                        }}
                        audio={false} videoConstraints={(deviceLabel === 'Default') ? { facingMode: 'environment' } : { deviceId: device.deviceId }} />
                    </div>
                    <br />
                    {state.stage === 'START_VIDEO_RECORDING' &&
                      <div className="fade-in">
                        <div id="container-circles" style={{ position: 'relative', bottom: '110px' }} onClick={handleStartVideoCapture}><div id="outer-circle"><div id="inner-circle"
                          style={{
                            height: '40px',
                            width: '40px',
                            margin: '-19.5px 0 0 -19.5px', background: 'red'
                          }}></div></div></div>
                        <h5 className="text-center">Start Video Recording</h5>
                      </div>
                    }
                    {state.stage === 'CAPTURE_LOCKER_APPERANCE' &&
                      <div className="fade-in">
                        <div id="container-circles" className="fade-in" style={{ position: 'relative', bottom: '110px' }} onClick={handleLockerApperance}><div id="outer-circle"><div id="inner-circle"></div></div></div>
                        <h5 className="text-center">Capture Locker Apperance</h5>
                        <Button variant='dark' block className="text-center"
                          onClick={props.onRestart}>
                          <FaTimes />Cancel
                        </Button>
                      </div>
                    }
                    {state.stage === 'CAPTURE_LOCKER_ITEMS' &&
                      <div className="fade-in">
                        <div id="container-circles" style={{ position: 'relative', bottom: '110px' }} onClick={handleLockerItems}><div id="outer-circle"><div id="inner-circle" ></div></div></div>
                        <h5 className="text-center">Capture Locker Items</h5>
                        <Button block variant="outline-secondary" className="text-center"
                          onClick={() => {
                            setState(prevState => {
                              [prevState.lockerImage, prevState.lockerItems].forEach((blob) => {
                                if (blob) {
                                  URL.revokeObjectURL(blob);
                                }
                              })
                              return { ...prevState, ...{ stage: 'CAPTURE_LOCKER_APPERANCE', lockerItems: '', lockerImage: '' } };
                            })
                          }}>
                          <FaArrowLeft />Back
                        </Button>
                        <Button variant='dark' block className="text-center"
                          onClick={props.onRestart}>
                          <FaTimes />Cancel
                        </Button>
                      </div>
                    }
                    {state.stage === 'STOP_VIDEO_RECORDING' &&
                      <div className="fade-in">
                        <div id="container-circles" style={{ position: 'relative', bottom: '110px' }} onClick={handleStopVideoCapture}><div id="outer-circle"><div id="inner-circle" style={{
                          height: '34px',
                          width: '34px',
                          margin: '-16.5px 0 0 -16.5px', borderRadius: '0%', background: 'red'
                        }}></div></div></div>
                        <h5 className="text-center">Stop Video Recording</h5>
                        <Button block variant="outline-secondary" className="text-center" onClick={() => {
                          setState(prevState => {
                            [prevState.lockerItemsCleared].forEach((blob) => {
                              if (blob) {
                                URL.revokeObjectURL(blob);
                              }
                            })
                            return { ...prevState, ...{ stage: 'CAPTURE_LOCKER_ITEMS_CLEARED', lockerItemsCleared: '' } };
                          })
                        }}>
                          <FaArrowLeft />Back
                        </Button>
                        <Button variant='dark' block className="text-center"
                          onClick={props.onRestart}>
                          <FaTimes />Cancel
                        </Button>
                      </div>
                    }
                  </div>
                </>
              }
            </>
          ))}
        </>
      }
    </>
  );
};


CaptureImageAndVideo.propTypes = {
  state:PropTypes.object,
  setState: PropTypes.func,
  onRestart: PropTypes.func
};